import { render, staticRenderFns } from "./TransferenciaCuentas.vue?vue&type=template&id=1ba71145&"
import script from "./TransferenciaCuentas.vue?vue&type=script&lang=js&"
export * from "./TransferenciaCuentas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports